//For hide/show autoplay failed alert in NP
export const showAutoplayFailedAlert = () => ({ type: 'SHOW_AUTOPLAY_FAILED_ALERT'})
export const hideAutoplayFailedAlert = () => ({ type: 'HIDE_AUTOPLAY_FAILED_ALERT'})
